import {Button, Spin} from 'antd';
import {useState} from 'react';
import {MdAddShoppingCart} from 'react-icons/md';
import {Link, useNavigate} from 'react-router-dom';

import {RqGetTrendingProducts} from '../../../reactQuery/apis';

const TrendingCategories = () => {
  const navigate = useNavigate();

  const {
    data: trendingData = [],
    isLoading,
    isError,
  } = RqGetTrendingProducts();

  const [activeImages, setActiveImages] = useState({});

  if (isLoading) {
    return (
      <div className={'w-full py-10 flex justify-center'}>
        <Spin size={'large'} />
      </div>
    );
  }

  const toDropboxRawUrl = (url = '') =>
    url.replace('www.dropbox.com', 'dl.dropboxusercontent.com')
      .replace('?dl=0', '');

  if (isError || trendingData.length === 0) {return null;}

  const visibleProducts = trendingData.slice(0, 8);

  const handleVariantImageChange = (productId, images) => {
    if (!images?.length) {return;}

    setActiveImages(prev => ({
      ...prev,
      [productId]: images[0],
    }));
  };

  return (
    <div className={'w-full flex  justify-center px-4 md:mt-16 mt-8'}>
      <div className={'section w-full'}>
        <h1 data-aos={'fade-up'} className={'title '}>Trending Products</h1>

        <div data-aos={'fade-up'} className={'grid grid-cols-1 md:grid-cols-4 gap-6'}>
          {visibleProducts.map(item => {
            const product = item.product;

            const originalPrice = Number(product.price);
            const discountPercent = product.discount || 0;
            const discountedPrice = Math.round(
              originalPrice - (originalPrice * discountPercent) / 100,
            );

            const displayImage =
  activeImages[product.id] ||
  product.imageUrl?.[0] ||
  product.variants?.[0]?.images?.[0];

            return (
              <div key={product.id} className={'bg-white rounded-xl shadow p-2'}>
                <Link data-aos={'fade-up'} to={`/product/${product.id}`} state={{product}}>
                  <div className={'flex md:flex-col flex-row'}>
                    <div>
                      <img
                        src={toDropboxRawUrl(displayImage || '/no-image.png')}
                        alt={product.productName}
                        className={'md:w-full w-44 h-56 md:h-80 object-cover rounded-lg'}
                        onError={e => {
                          console.log('Image failed for:', product);
                          e.target.src = '/no-image.png';
                        }}
                      />
                    </div>

                    <div className={'flex flex-col justify-center pl-2'}>
                      {/* Color Switcher */}
                      {product.variants?.length > 0 && (
                        <div className={'md:flex hidden gap-2 mt-3 pl-2'}>
                          {product.variants.map((variant, idx) => {
                            const hasImages = variant.images?.length > 0;
                            const isActive =
        activeImages[product.id] === variant.images?.[0];

                            return (
                              <button
                                key={idx}
                                type={'button'}
                                title={variant.color}
                                disabled={!hasImages}
                                onMouseEnter={() =>
                                  handleVariantImageChange(product.id, variant.images)
                                }
                                onClick={() =>
                                  handleVariantImageChange(product.id, variant.images)
                                }
                                className={`w-5 h-5 rounded-full border transition-all duration-200
            ${isActive ? 'border-primary-900 scale-110' : 'border-gray-300'}
            ${!hasImages ? 'opacity-50 cursor-not-allowed' : ''}
          `}
                                style={{backgroundColor: variant.color}}
                              />
                            );
                          })}
                        </div>
                      )}

                      <h3 className={'mt-2 text-xl pl-2 font-semibold'}>{product.productName}</h3>

                      <div className={'flex md:flex-row pl-2 flex-col gap-2 mb-2 mt-2'}>
                        <p className={'font-semibold md:text-xl text-lg'}>₹{discountedPrice}</p>
                        {product.discount > 0 && (
                          <>
                            <div className={'flex gap-2'}>
                              <p className={'line-through md:font-normal font-extralight text-gray'}>
                            ₹{product.price}
                              </p>
                              <span className={'bg-red-600 flex justify-center items-center text-white px-2 rounded-full md:text-sm'}>
                            -{product.discount}%
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                      {product.variants?.length > 0 && (
                        <div className={'md:hidden flex gap-2 mt-3 pl-2'}>
                          {product.variants.map((variant, idx) => {
                            const hasImages = variant.images?.length > 0;
                            const isActive =
        activeImages[product.id] === variant.images?.[0];

                            return (
                              <button
                                key={idx}
                                type={'button'}
                                title={variant.color}
                                disabled={!hasImages}
                                onMouseEnter={() =>
                                  handleVariantImageChange(product.id, variant.images)
                                }
                                onClick={() =>
                                  handleVariantImageChange(product.id, variant.images)
                                }
                                className={`w-5 h-5 rounded-full border transition-all duration-200
            ${isActive ? 'border-primary-900 scale-110' : 'border-gray-300'}
            ${!hasImages ? 'opacity-50 cursor-not-allowed' : ''}
          `}
                                style={{backgroundColor: variant.color}}
                              />
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
              
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrendingCategories;
